import React, { forwardRef, MutableRefObject, useEffect, useRef } from 'react';
import { isFunction } from 'lodash';

type ICustomKeydownInputProps = {
  onKeyDown?: Function;
  customOnKeydown?: (event: any, baseOnKeyDown?: Function) => void;
  highlightTextOnMount?: boolean;
  inGrid?: boolean;
  inputRef?: MutableRefObject<any>;
  readOnly?: boolean;
};

export const CustomKeydownInput = forwardRef(
  (
    {
      onKeyDown = undefined,
      customOnKeydown,
      highlightTextOnMount = true,
      inGrid = false,
      inputRef,
      ...rest
    }: ICustomKeydownInputProps,
    ref
  ) => {
    const innerInputRef = useRef<any>();
    useEffect(() => {
      //On mount - Select all text (Ready for manual editing by the user).
      if (highlightTextOnMount) {
        innerInputRef.current?.select();
      }
    }, [highlightTextOnMount]);

    return (
      <input
        ref={(el) => {
          innerInputRef.current = el;
          if (inputRef) {
            inputRef.current = el;
          }
          if (isFunction(ref)) {
            ref(el);
          } else if (ref) {
            //If ref wasn't a function, assume it's a MutableRefObject
            (ref as MutableRefObject<any>).current = el;
          }
        }}
        {...rest}
        onKeyDown={(event) => {
          if (customOnKeydown) {
            customOnKeydown(event, onKeyDown);
          } else {
            onKeyDown?.(event);
          }
        }}
        style={
          inGrid
            ? { position: 'relative', display: 'inline-block', width: '100%', border: 'none', height: '31px' }
            : {
                border: 'none',
                borderBottom: rest.readOnly ? 'none' : '1px solid #ccc',
                width: '100%',
                fontSize: '14px',
                color: 'rgba(0,0,0,0.87)',
                verticalAlign: 'middle',
                padding: 0,
              }
        }
      />
    );
  }
);
